import { useState, useMemo, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryNav from '@/pages/home/components/CategoryNav';
import LatestSection from '@/pages/home/components/LatestSection';
import { getArticlesByCategory, articles as allArticles } from '@/mocks/articles';
import { categories, siteInfo } from '@/mocks/site';

export default function CategoryPage() {
  const { slug = 'all' } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(slug);

  useEffect(() => {
    setActiveCategory(slug);
  }, [slug]);

  const handleCategoryChange = (newSlug: string) => {
    setActiveCategory(newSlug);
    navigate(`/category/${newSlug}`);
  };

  const filteredArticles = useMemo(() => getArticlesByCategory(activeCategory), [activeCategory]);

  const currentCategory = categories.find((c) => c.slug === activeCategory) || categories[0];
  const allCount = allArticles.length;

  const pageTitle = activeCategory === 'all'
    ? `全部黑料合集 - ${siteInfo.name}`
    : `${currentCategory.name} - ${siteInfo.name}`;
  const pageDescription = activeCategory === 'all'
    ? `浏览${siteInfo.name}全部黑料合集，涵盖明星爆料、网红黑料、娱乐圈、社会热点、商业内幕等热门分类，每日更新${allCount}+条独家内幕。`
    : `浏览${siteInfo.name}${currentCategory.name}频道，最新${currentCategory.name}黑料曝光汇总，每日更新独家内幕与热门爆料。`;
  const pageKeywords = activeCategory === 'all'
    ? `${siteInfo.keywords}`
    : `${currentCategory.name},黑料,爆料,吃瓜,${siteInfo.name}`;

  const categoryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: pageTitle,
    description: pageDescription,
    url: `${siteInfo.url}/category/${activeCategory}`,
    isPartOf: {
      '@id': `${siteInfo.url}/#website`,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(categoryJsonLd)}</script>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <link rel="canonical" href={`${siteInfo.url}/category/${activeCategory}`} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={`${siteInfo.url}/category/${activeCategory}`} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <div className="pt-20 bg-background-50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: activeCategory === 'all' ? '全部黑料' : currentCategory.name },
            ]}
          />
          <div className="flex items-center gap-3 mb-4">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950">
              {activeCategory === 'all' ? '全部黑料合集' : currentCategory.name}
            </h1>
            <span className="text-sm text-foreground-400 font-label">
              共 {filteredArticles.length} 条爆料
            </span>
          </div>
          <CategoryNav active={activeCategory} onSelect={handleCategoryChange} />
        </div>
      </div>
      <LatestSection articles={filteredArticles} />
    </>
  );
}